import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';

/** @class TabPanelMixin */
/** @method */
export var TabPanelMixin = function TabPanelMixin(props) {
  return token({
    backgroundColor: 'Tabs.backgroundColor',
    padding: 'Tabs.Panel.padding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      padding = _ref.padding;
    return css(["background-color:", ";padding:", ";", ""], backgroundColor, padding ? padding + "px" : spaceMixin('sm')(props), spacingMixin(props));
  })(props);
};